import { Box, Divider, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material"
import { useState, useEffect } from "react"
import FilterHelper from '../../views/StockScreener/common/FieldsHelper'

const InputParameter = (props) => {

	const [operator, setOperator] 		= useState('')
	const [parameter, setParameter] 	= useState('')

	useEffect(() => {
		setOperator(props.value?.operator || '')
		setParameter(props.value?.parameter || '')
	}, [props.value])

	const handleOperatorChange = (e) => {
		setOperator(e.target.value)
		if (props.onChange) props.onChange(e.target.value, parameter)
	}

	const handleParameterChange = (e) => {
		setParameter(e.target.value)
		if (props.onChange) props.onChange(operator, e.target.value)	
	}

	const handleNumericParameterChange = (e) => {
		const value = e.target.value.replace(/[^0-9,]|,(?=.*,)/g,'')
		setParameter(value)
		if (props.onChange) props.onChange(operator, value)	
	}

	return (
		<Stack direction="row" spacing={1}>
			{ props.divider ? (
				<Divider orientation="vertical" flexItem />
			) : null}

			{ props.field && props.field.type === 'numeric' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl error={props.error} sx={{ width: 75, flexShrink: 0 }}>
						<InputLabel size={props.size || "medium"}>Op.</InputLabel>
						<Select label="Op." value={operator} onChange={handleOperatorChange} size={props.size || "medium"}>
							<MenuItem value="lt">{props.size === 'small' ? '<' : 'Menor que'}</MenuItem>
							<MenuItem value="le">{props.size === 'small' ? '≤' : 'Menor ou igual a'}</MenuItem>
							<MenuItem value="eq">{props.size === 'small' ? '=' : 'Igual a'}</MenuItem>
							<MenuItem value="ge">{props.size === 'small' ? '≥' : 'Maior ou igual a'}</MenuItem>
							<MenuItem value="gt">{props.size === 'small' ? '>' : 'Maior que '}</MenuItem>
						</Select>
					</FormControl>
					<Box flex={1}>
						<TextField 
							label="Valor" 
							value={parameter} 
							fullWidth 
							inputProps={{ maxLength: 10 }}
							onChange={handleNumericParameterChange} 
							size={props.size || "medium"}
							error={props.error}
						/>
					</Box>
				</Stack>

			) : props.field && props.field.type === 'options' ? (
				<Stack direction= 'row' spacing={1} width={'100%'} display={'flex'} flex={1}>
					<FormControl sx={{width: 160}}>
						<InputLabel size={props.size || "medium"}>Op.</InputLabel>
						{ props.field.unit === 'array' ? (
							<Select label="Op." value={operator} onChange={handleOperatorChange} size={props.size || "medium"}>
								<MenuItem value="in">{props.size === 'small' ? '∈' : 'Inclui'}</MenuItem>
								<MenuItem value="ni">{props.size === 'small' ? '∉' : 'Não Inclui'}</MenuItem>
							</Select>	
						) : props.field.unit === 'number' ? (
							<FormControl>
								<InputLabel size={props.size || "medium"}>Op.</InputLabel>
								<Select label="Op." value={operator} onChange={handleOperatorChange} size={props.size || "medium"}>
									<MenuItem value="lt">{props.size === 'small' ? '<' : 'Menor que'}</MenuItem>
									<MenuItem value="le">{props.size === 'small' ? '≤' : 'Menor ou igual a'}</MenuItem>
									<MenuItem value="eq">{props.size === 'small' ? '=' : 'Igual a'}</MenuItem>
									<MenuItem value="ge">{props.size === 'small' ? '≥' : 'Maior ou igual a'}</MenuItem>
									<MenuItem value="gt">{props.size === 'small' ? '>' : 'Maior que '}</MenuItem>
								</Select>
							</FormControl>							
						) : (
							<Select label="Op." value={operator} onChange={handleOperatorChange} size={props.size || "medium"}>
								<MenuItem value="eq">{props.size === 'small' ? '=' : 'Igual a'}</MenuItem>
								<MenuItem value="ne">{props.size === 'small' ? '≠' : 'Diferente de'}</MenuItem>
							</Select>	
						)}
					</FormControl>
					<Box flex={1} alignItems={'center'} display={'flex'}>
						<FormControl fullWidth>{FilterHelper.getOptionsComponent(props.field.id, parameter, handleParameterChange, props.requiredParameter)}</FormControl>
					</Box>
				</Stack>
			) : null}

		</Stack>
	)

}

export default InputParameter